export default "__VITE_ASSET__CTL_XVPJ__"